import { css } from 'styled-components';

/**
 * Single-selection highlight for table rows (folders, stories, clips, publish
 * records).
 *
 * Per the design system, selection uses gold (`--accent`) — never green — with
 * the indicator on the left. A selected row gets an elevated background plus a
 * gold left bar, making it clearly distinct from the neutral grey hover state.
 * Selection is mutually exclusive within a list, so at most one row ever
 * carries this at a time.
 */
export const selectedRowIndicator = css`
  background: var(--surface-elevated);
  box-shadow: inset 3px 0 0 var(--accent);
`;
